<template>
  <router-link class="item" :to="{ name: 'group', params: { groupId: group.original.id } }">
    <div class="ui equal height grid">
      <div class="thirteen wide column">
        <div class="row" v-if="group.original.domain">
          <div class="domain ellipsis" :title="group.original.domain">
            {{ group.original.domain }}
          </div>
        </div>
        <div class="row">
          <div class="group ellipsis" :title="group.original.name" v-html="group.string" />
        </div>
      </div>
      <div class="one wide column">
        <color-label :color="group.original.color" size="tiny" />
      </div>
    </div>
  </router-link>
</template>

<style lang="scss" scoped>
@charset "utf-8";
@import '../../scss/variables';

.item {
  height: 55px;
}

.group {
  font-weight: bold;
}

.ellipsis {
  width: 85%;
}

.domain {
  font-size: x-small;
  padding-bottom: 5px;
}
</style>

<script>
// @flow
import { ColorLabel } from 'ui'

export default {
  name: 'singlegroup',
  components: { ColorLabel },

  props: ['group']
}
</script>
